import { atom } from 'jotai';
import { ReactNode } from 'react';

export const isSidebarOpenAtom = atom<boolean>(false);

export const isForceUpdatingAtom = atom<boolean>(false);

export const loadingAtom = atom<boolean>(false);

export const isModalOpenAtom = atom<boolean>(false);

export const modalChildrenAtom = atom<ReactNode|null>(null);

export const modalCancelableAtom = atom<boolean>(false);

export const isBottomSheetOpenAtom = atom<boolean>(false);

export const bottomSheetChildrenAtom = atom<ReactNode | null>(null);

export const bottomSheetTitleAtom = atom<string>('');
